<template>
    <div class="electron-menu" v-if="configStore.electronMode">
        <div class="drag-ctrl"></div>
        <div class="icon iconfont icon-minimize" @click="onMinimize()"> </div>
        <div v-if="isShowMaximize && windowMaximized" class="icon iconfont icon-unmaximize" @click="onUnmaximize()"></div>
        <div v-if="isShowMaximize && !windowMaximized" class="icon iconfont icon-maximize" @click="onMaximize()"></div>
        <div class="icon iconfont icon-close" @click="onClose()"> </div>
    </div>
</template>
<script>
export default {
    name: "electronMenu",
    data() {
        return {
            windowMaximized: false
        }
    },
    mounted() {
        if (!window.electronAPI) {
            return;
        }
        window.electronAPI.invoke('isMaximized').then((maximized) => {
            this.windowMaximized = !!maximized;
        });
        window.electronAPI.receive('window-maximize-change', (maximized) => {
            this.windowMaximized = !!maximized;
        });
    },
    methods: {
        onMinimize() {
            window.electronAPI.sendEvent('minimize');
        },
        onUnmaximize() {
            this.windowMaximized = false;
            window.electronAPI.sendEvent('unmaximize');
        },
        onMaximize() {
            this.windowMaximized = true;
            window.electronAPI.sendEvent('maximize');
        },
        onClose() {
            window.electronAPI.sendEvent('close');
        }
    },
    computed: {
        isShowMaximize() {
            const authPageNames = ['TenantEntry', 'Login', 'Register', 'ResetPwd'];
            return !authPageNames.includes(this.$route.name);
        }
    }
}
</script>
<style scoped lang="scss">
.electron-menu {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    width: 100%;
    height: 25px;
    z-index: 9;
    align-items: center;
    box-sizing: border-box;
    background: var(--electron-shell-bg);
    border-bottom: 1px solid var(--electron-shell-border);
    color: var(--electron-shell-text);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    .drag-ctrl {
        flex: 1;
        height: 100%;
        -webkit-app-region: drag;
        cursor: move;
    }

    .icon {
        margin: 0 8px;
        color: var(--electron-shell-text);
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        padding: 2px;
        border-radius: 5px;
        transition: background-color 0.2s ease, color 0.2s ease;
        &:hover {
            background: var(--electron-shell-hover-bg);
        }
    }
}
</style>
